import { refresh as identityRefresh } from '@repletoryreach/sdk-api/identity';
import { setTokens, clearTokens, readRefreshToken, readImpersonationToken } from '@repletoryreach/sdk-api';

export async function refreshAccessToken(): Promise<string | null> {
  // W31: never refresh during impersonation: minting a normal token from the
  // persisted refresh token would silently swap the session back to the
  // admin's own identity mid-impersonation. Impersonation tokens just expire.
  if (readImpersonationToken()) return null;

  const rt = readRefreshToken();
  if (!rt) {
    clearTokens();
    return null;
  }
  try {
    const res = await identityRefresh({ refresh_token: rt });
    setTokens(res.data.token, res.data.refresh_token);
    return res.data.token;
  } catch {
    clearTokens();
    return null;
  }
}
